import React, { useState, useEffect } from "react";
import {
  InsertEventTicket,
  UpdateEventTickets,
  GetAddons,
  GetFormes,
  GetTaxSettings,
} from "../../../api/Webservices";
import AddonsModal from "./AddonsModal";
import BasicTab from "./tabs/BasicTab";
import PricingTab from "./tabs/PricingTab";
import FormTab from "./tabs/FormTab";
import SettingsTab from "./tabs/SettingsTab";
import GuestTicketForm from "./GuestTicketForm";
import "./EventTickets.css";
import { LuTickets } from "react-icons/lu";
import { RiPriceTag2Fill } from "react-icons/ri";
import {
  FaWpforms,
  FaCheck,
  FaTimes,
  FaArrowLeft,
  FaArrowRight,
} from "react-icons/fa";
import { IoMdSettings } from "react-icons/io";
import { showToast, ToastMessage } from "../../Shared/ToastMessage";
const CreateTicket = ({
  show,
  onHide,
  onCreateTicket,
  setShowAddOns,
  editMode = false,
  ticketToEdit = null,
  onUpdate,
  getValidation,
}) => {
  const [notification, setNotification] = useState({
    show: false,
    type: "",
    message: "",
  });
  console.log(ticketToEdit, "ticketToEdit");
  const [previewTicket, setPreviewTicket] = useState(null);
  const [activeTab, setActiveTab] = useState("basic");
  const [errors, setErrors] = useState({
    name: "",
    currency: "",
    guestName: "",
    selectedForm: "",
  });

  const [showGuestTicket, setShowGuestTicket] = useState(false);
  const [guestTicketMode, setGuestTicketMode] = useState("add");
  const [showGuestTicketForm, setShowGuestTicketForm] = useState(false);
  const [guestTicket, setGuestTicket] = useState(null);
  const [isSameStates, setIsSameState] = useState(false);
  const [guestTicketState, setGuestTicketState] = useState({
    name: "",
    qtyAvailable: "",
    description: "",
    group: "",
    selected_form: null,
    form_details: null,
    pricingType: "free",
    currency: "INR",
    priceOption: "fixed",
    fixedPrice: "",
    variablePrices: [{ price: "", validUntilDate: null, validUntilTime: null }],
    taxEnabled: false,
    taxIncluded: true,
    taxRate: "18",
    taxName: "GST",
    taxOptions: [],
    taxRegisTrationNumber: null,
    taxDisplay: "add_to_total",
    isPrivate: false,
    showSchedule: false,
    saleStartDate: null,
    saleStartTime: null,
    saleEndDate: null,
    saleEndTime: null,
    showLimits: true,
    ticket_min_order: "1",
    ticket_max_order: "1000",
    qrcode: false,
    ticketStatus: "onsale",
  });
  const EventID = localStorage.getItem("eventId") || "";

  const [newTicket, setNewTicket] = useState({
    name: "",
    qtyAvailable: "",
    description: "",
    group: "",
    selected_form: null,
    pricingType: "free",
    currency: "INR",
    priceOption: "variable",
    fixedPrice: "",
    variablePrices: [{ price: "", validUntilDate: null, validUntilTime: null }],
    taxEnabled: false,
    taxIncluded: true,
    taxRate: "",
    taxName: "GST",
    taxRegisTrationNumber: null,
    taxOptions: [],
    taxDisplay: "add_to_total",
    isPrivate: false,
    showSchedule: false,
    saleStartDate: null,
    saleStartTime: null,
    saleEndDate: null,
    saleEndTime: null,
    showLimits: false,
    ticket_min_order: "1",
    ticket_max_order: "",
    qrcode: false,
    ticketStatus: "paused",
    taxoptionsShower: [],
  });
  const toggleLimits = () => {
    setNewTicket((prev) => {
      const newShowLimits = !prev.showLimits;

      return {
        ...prev,
        showLimits: newShowLimits,
        ...(newShowLimits
          ? {}
          : {
              ticket_min_order: 1,
              ticket_max_order: "",
            }),
      };
    });
  };

  const [showGuestDescription, setShowGuestDescription] = useState(false);
  const [showGroup, setShowGroup] = useState(false);
  const [formsList, setFormsList] = useState([]);
  const [selectedForm, setSelectedForm] = useState(null);
  const [isLoadingForms, setIsLoadingForms] = useState(false);
  const [showFormDropdown, setShowFormDropdown] = useState(false);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [guestSelectedAddons, setGuestSelectedAddons] = useState(
    selectedAddons || []
  );
  const [addons, setAddons] = useState([]);
  const [isLoadingAddons, setIsLoadingAddons] = useState(false);
  const [showAddonsModal, setShowAddonsModal] = useState(false);

  const closeNotification = () => {
    setNotification({ ...notification, show: false });
  };

  const formatAddonForUI = (addon, currentTicketId = null) => {
    const variants = addon.variant_options
      ? addon.variant_options.map((v, idx) => ({
          id: idx + 1,
          name: v.variant_name,
          price: v.variant_price,
          apiVariant: v,
        }))
      : [];

    const selectedVariant =
      variants.length > 0
        ? {
            name: variants[0].name,
            price: variants[0].price,
            variant_name: variants[0].apiVariant.variant_name,
            variant_price: variants[0].apiVariant.variant_price,
          }
        : null;

    let chooseQuantity = 1;
    if (
      currentTicketId &&
      addon.linked_tickets &&
      addon.linked_tickets.length > 0
    ) {
      const linkedTicket = addon.linked_tickets.find(
        (lt) => lt.ticket_id === currentTicketId
      );
      if (linkedTicket) {
        chooseQuantity = linkedTicket.max_quantity;
      }
    }

    return {
      id: addon.id,
      name: addon.add_on_name,
      description: addon.description || "",
      price: addon.price,
      currency: addon.currency || "INR",
      variants,
      hasVariants: variants.length > 0,
      type: addon.addons_type || "single",
      price_type: addon.price_type || "paid",
      selectedVariant,
      status: addon.addon_status || "onsale",
      quantity: addon.quantity || 1,
      choose_quantity: chooseQuantity, // Use calculated chooseQuantity instead of hardcoded 1
      isMandatory: addon.is_mandatory || false,
      // selectedVariant: // REMOVED DUPLICATE SELECTED VARIANT
      //   variants.length > 0
      //     ? {
      //         name: variants[0].name,
      //         price: variants[0].price,
      //         variant_name: variants[0].apiVariant.variant_name,
      //         variant_price: variants[0].apiVariant.variant_price,
      //       }
      //     : null,
      tax_type: addon.tax_type,
      tax_options: addon.tax_options || [],
      linkedTickets: addon.linked_tickets
        ? addon.linked_tickets.map((lt) => ({
            ticket_id: lt.ticket_id,
            maxQuantity: lt.max_quantity || 1,
          }))
        : [],
    };
  };

  const fetchForms = async () => {
    setIsLoadingForms(true);
    try {
      const res = await GetFormes(EventID);
      if (!res || !res.data || !res.data.forms) {
        console.error("Invalid GetFormes response:", res);
        setFormsList([]);
        return;
      }
      const formsArray = res.data.forms;
      if (!Array.isArray(formsArray)) {
        console.error("forms is not an array:", formsArray);
        setFormsList([]);
        return;
      }
      const simplifiedForms = formsArray.map((formData) => {
        let parsedFields = [];
        if (formData.fileds) {
          try {
            let fieldsString = formData.fileds;
            if (
              typeof fieldsString === "string" &&
              fieldsString.startsWith('"') &&
              fieldsString.endsWith('"')
            ) {
              fieldsString = fieldsString.slice(1, -1);
            }
            fieldsString = fieldsString
              .replace(/\\"/g, '"')
              .replace(/\\\\/g, "\\")
              .replace(/\\n/g, "\n")
              .replace(/\\r/g, "\r")
              .replace(/\\t/g, "\t");
            parsedFields = JSON.parse(fieldsString);
          } catch (parseError) {
            console.error(
              "Error parsing fields for form",
              formData.id,
              ":",
              parseError
            );
            parsedFields = [];
          }
        }
        return {
          id: formData.id,
          name: formData.form_title || `Untitled Form ${formData.id}`,
          event_id: formData.event_id || EventID,
          form_type: formData.form_type || 1,
          form_id: formData.form_id,
          fields: parsedFields,
          description: formData.form_description || "",
          status: formData.status || "active",
          form_title: formData.form_title,
          form_description: formData.form_description,
        };
      });
      setFormsList(simplifiedForms);
    } catch (error) {
      console.error("Error fetching forms:", error);
      setFormsList([]);
    } finally {
      setIsLoadingForms(false);
    }
  };

  const handleVariantSelection = (addonId, variantDetails) => {
    const updatedAddons = selectedAddons.map((item) =>
      item.id === addonId
        ? {
            ...item,
            selectedVariant: {
              name: variantDetails.name,
              price: variantDetails.price,
              variant_name: variantDetails.name,
              variant_price: variantDetails.price,
            },
          }
        : item
    );
    setSelectedAddons(updatedAddons);
  };

  const handleGuestVariantSelection = (addonId, variantDetails) => {
    setGuestSelectedAddons(
      guestSelectedAddons.map((item) =>
        item.id === addonId
          ? {
              ...item,
              selectedVariant: {
                name: variantDetails.name,
                price: variantDetails.price,
                variant_name: variantDetails.name,
                variant_price: variantDetails.price,
              },
            }
          : item
      )
    );
  };

  const fetchAddons = async (status = "onsale") => {
    setIsLoadingAddons(true);
    try {
      const response = await GetAddons(status);
      if (response && response.data && response.data.addons) {
        const currentTicketId =
          editMode && ticketToEdit ? ticketToEdit.id : null;
        const processedAddons = response.data.addons.map((addon) =>
          formatAddonForUI(addon, currentTicketId)
        );
        setAddons(processedAddons);
      } else {
        setAddons([]);
      }
    } catch (error) {
      setNotification({
        show: true,
        type: "error",
        message: "Failed to load add-ons. Please try again.",
      });
    } finally {
      setIsLoadingAddons(false);
    }
  };

  useEffect(() => {
    fetchForms();
    fetchAddons();

    const fetchTaxSettings = async () => {
      try {
        const response = await GetTaxSettings(EventID);
        const isSameState = response.state_is_same;
        if (isSameState === "yes") {
          setIsSameState(true);
        } else {
          setIsSameState(false);
        }
        const settings = response?.data?.[0];
        console.log(isSameState, "setting123123s");
        let parsedTaxSettings = {};

        if (settings?.tax_settings) {
          try {
            parsedTaxSettings = JSON.parse(settings.tax_settings);
          } catch (err) {
            console.error("Error parsing tax_settings:", err);
            parsedTaxSettings = {
              tax_registration_number: null,
              tax_display: "add_to_total",
              tax_options: [],
            };
          }
        } else {
          parsedTaxSettings = {
            tax_registration_number: null,
            tax_display: "add_to_total",
            tax_options: [],
          };
        }

        // Filter tax options based on state_is_same
        const filteredTaxOptions =
          isSameState === "yes"
            ? parsedTaxSettings.tax_options.filter(
                (option) =>
                  option.tax_name === "SGST" || option.tax_name === "CGST"
              )
            : parsedTaxSettings.tax_options.filter(
                (option) => option.tax_name === "IGST"
              );

        setNewTicket((prev) => ({
          ...prev,
          taxOptions: parsedTaxSettings.tax_options || [],
          taxoptionsShower: filteredTaxOptions,
          taxRegisTrationNumber:
            parsedTaxSettings.tax_registration_number || null,
          taxDisplay: parsedTaxSettings.tax_display || "add_to_total",
          taxEnabled: (parsedTaxSettings.tax_options || []).length > 0,
          taxIncluded: parsedTaxSettings.tax_display === "include_in_price",
          taxRate:
            parsedTaxSettings.tax_options?.[0]?.tax_percentage?.toString() ||
            "18",
          taxName: parsedTaxSettings.tax_options?.[0]?.tax_name || "GST",
        }));

        setGuestTicketState((prev) => ({
          ...prev,
          taxOptions: filteredTaxOptions,
          taxRegisTrationNumber:
            parsedTaxSettings.tax_registration_number || null,
          taxDisplay: parsedTaxSettings.tax_display || "add_to_total",
          taxEnabled: filteredTaxOptions.length > 0,
          taxIncluded: parsedTaxSettings.tax_display === "include_in_price",
          taxRate: filteredTaxOptions[0]?.tax_percentage?.toString() || "18",
          taxName:
            filteredTaxOptions[0]?.tax_name ||
            (isSameState === "yes" ? "SGST" : "IGST"),
        }));
      } catch (error) {
        console.error("Error fetching tax settings:", error);
        setNotification({
          show: true,
          type: "error",
          message: "Failed to fetch tax settings. Using default values.",
        });
      }
    };

    fetchTaxSettings();
  }, [EventID]);

  const submitTicketToAPI = async (is_draft = false) => {
    try {
      if (editMode && (!ticketToEdit || !ticketToEdit.id)) {
        console.error(
          "Error: ticketToEdit or ticketToEdit.id is missing in edit mode"
        );
        setNotification({
          show: true,
          type: "error",
          message: "Cannot update ticket: Invalid ticket ID.",
        });
        return;
      }

      let formattedData;

      if (editMode && ticketToEdit && ticketToEdit.id) {
        const matchedForm = formsList.find(
          (f) => f.id === Number(ticketToEdit.selected_form)
        );

        if (matchedForm) {
          setSelectedForm(matchedForm);
        } else {
          console.warn(
            "No matching form found for selected_form:",
            ticketToEdit.selected_form
          );
        }
        formattedData = {
          id: ticketToEdit.id,
          event_id: EventID,
          ticket_group_id:
            newTicket.group || ticketToEdit.ticket_group_id || null,
          user_id: ticketToEdit.user_id || 1,
          ticket_name: newTicket.name,
          description: newTicket.description || "",
          price:
            newTicket.pricingType === "paid"
              ? newTicket.priceOption === "fixed"
                ? Number.parseFloat(newTicket.fixedPrice)
                : Number.parseFloat(newTicket.variablePrices[0]?.price || 0)
              : null,
          quantity: newTicket.qtyAvailable
            ? Number.parseInt(newTicket.qtyAvailable)
            : ticketToEdit.quantity || 100000,
          start_sale: (() => {
            try {
              return newTicket.saleStartDate
                ? `${
                    new Date(newTicket.saleStartDate)
                      .toISOString()
                      .split("T")[0]
                  } ${
                    newTicket.saleStartTime
                      ? new Date(newTicket.saleStartTime)
                          .toTimeString()
                          .split(" ")[0]
                      : "00:00:00"
                  }`
                : ticketToEdit.start_sale || null;
            } catch (e) {
              return ticketToEdit.start_sale || null;
            }
          })(),
          end_sale: (() => {
            try {
              return newTicket.saleEndDate
                ? `${
                    new Date(newTicket.saleEndDate).toISOString().split("T")[0]
                  } ${
                    newTicket.saleEndTime
                      ? new Date(newTicket.saleEndTime)
                          .toTimeString()
                          .split(" ")[0]
                      : "23:59:59"
                  }`
                : ticketToEdit.end_sale || null;
            } catch (e) {
              return ticketToEdit.end_sale || null;
            }
          })(),
          ticket_type:
            newTicket.pricingType || ticketToEdit.ticket_type || "free",
          currency: newTicket.currency || ticketToEdit.currency || "INR",
          pricing_option:
            newTicket.priceOption || ticketToEdit.pricing_option || "fixed",
          tax_type: newTicket.taxEnabled
            ? newTicket.taxIncluded
              ? "Including Tax"
              : "Excluding Tax"
            : "No Tax",
          tax_options: newTicket.taxOptions || ticketToEdit.tax_options || [],
          selected_form: selectedForm?.id || ticketToEdit.selected_form || null,
          tax_registration_no:
            newTicket.taxRegisTrationNumber ||
            ticketToEdit.tax_registration_no ||
            null,
          form_details: selectedForm
            ? JSON.stringify(selectedForm.fields)
            : ticketToEdit.form_details || "",
          schedule_sale: (() => {
            try {
              return newTicket.saleStartDate
                ? `${
                    new Date(newTicket.saleStartDate)
                      .toISOString()
                      .split("T")[0]
                  } ${
                    newTicket.saleStartTime
                      ? new Date(newTicket.saleStartTime)
                          .toTimeString()
                          .split(" ")[0]
                      : "00:00:00"
                  }`
                : ticketToEdit.schedule_sale || null;
            } catch (e) {
              return ticketToEdit.schedule_sale || null;
            }
          })(),
          schedule_sale_enabled: newTicket.showSchedule
            ? "yes"
            : ticketToEdit.schedule_sale_enabled || "no",
          private_ticket: newTicket.isPrivate
            ? "yes"
            : ticketToEdit.private_ticket || "no",
          ticket_min_order: newTicket.showLimits
            ? Number.parseInt(newTicket.ticket_min_order) || 0
            : ticketToEdit.ticket_min_order || 0,
          ticket_max_order: newTicket.showLimits
            ? Number.parseInt(newTicket.ticket_max_order) || 0
            : ticketToEdit.ticket_max_order || 0,
          show_promotional_label: "yes",
          promotional_label_text: "Best Value",
          qrcode: newTicket.qrcode ? "yes" : "no",
          ticket_status: newTicket.ticketStatus || "onsale",
          onsale_status:
            newTicket.onsale_status === "onsale"
              ? "enable"
              : ticketToEdit.onsale_status || "enable",
          variable_prices:
            newTicket.priceOption === "variable"
              ? newTicket.variablePrices.map((price) => {
                  const defaultDate = "2025-05-05";
                  const defaultTime = "23:59:59";
                  let validDate;
                  try {
                    validDate = price.validUntilDate
                      ? new Date(price.validUntilDate)
                          .toISOString()
                          .split("T")[0]
                      : defaultDate;
                  } catch (e) {
                    validDate = defaultDate;
                  }
                  let validTime;
                  try {
                    validTime = price.validUntilTime
                      ? new Date(price.validUntilTime)
                          .toTimeString()
                          .split(" ")[0]
                      : defaultTime;
                  } catch (e) {
                    validTime = defaultTime;
                  }
                  return {
                    price: Number.parseFloat(price.price) || 0,
                    valid_till: `${validDate} ${validTime}`,
                  };
                })
              : ticketToEdit.variable_prices || null,
          addons:
            selectedAddons.length > 0
              ? selectedAddons.map((addon) => ({
                  id: addon.id,
                  user_id: 1,
                  event_id: EventID,
                  isMandatory: addon.isMandatory || false,
                  addons_type: addon.type || "single",
                  add_on_name: addon.name,
                  description: addon.description || "",
                  price_type: addon.price_type || "paid",
                  price:
                    Number.parseFloat(addon.price) ||
                    (addon.selectedVariant
                      ? Number.parseFloat(addon.selectedVariant.variant_price)
                      : 0),
                  currency: addon.currency || "INR",
                  tax_type: addon.tax_type,
                  tax_options: addon.tax_options || newTicket.taxOptions,
                  variant_options: Array.isArray(addon.variants)
                    ? addon.variants.map((variant) => ({
                        variant_name: variant.apiVariant.variant_name,
                        quantity_available:
                          variant.apiVariant.quantity_available,
                        variant_price: variant.apiVariant.variant_price,
                      }))
                    : [],
                  selected_variant: addon.selectedVariant
                    ? {
                        variant_name: addon.selectedVariant.variant_name,
                        variant_price: addon.selectedVariant.variant_price,
                      }
                    : null,
                  linked_tickets:
                    addon.linkedTickets && addon.linkedTickets.length > 0
                      ? addon.linkedTickets.map((lt) => ({
                          ticket_id: lt.ticket_id,
                          max_quantity: lt.maxQuantity || 1,
                        }))
                      : [],
                  choose_quantity: addon.choose_quantity || 1,
                  quantity: addon.quantity || 1,
                  addon_status: addon.status || "onsale",
                  created_at: addon.created_at || new Date().toISOString(),
                }))
              : [],
          created_at: ticketToEdit.created_at || new Date().toISOString(),
        };

        if (guestTicket) {
          formattedData.guest_details = {
            ticket_name: guestTicket.ticket_name || guestTicket.name || "",
            description: guestTicket.description || "",
            price:
              guestTicket.ticket_type === "paid"
                ? Number.parseFloat(guestTicket.price)
                : null,
            quantity: Number.parseInt(guestTicket.quantity) || 50,
            start_sale: guestTicket.start_sale
              ? `${
                  new Date(guestTicket.start_sale).toISOString().split("T")[0]
                } ${
                  guestTicket.start_sale
                    ? new Date(guestTicket.start_sale)
                        .toTimeString()
                        .split(" ")[0]
                    : "00:00:00"
                }`
              : null,
            end_sale: guestTicket.end_sale
              ? `${
                  new Date(guestTicket.end_sale).toISOString().split("T")[0]
                } ${
                  guestTicket.end_sale
                    ? new Date(guestTicket.end_sale)
                        .toTimeString()
                        .split(" ")[0]
                    : "23:59:59"
                }`
              : null,
            ticket_type: guestTicket.ticket_type || "free",
            currency: guestTicket.currency || "INR",
            pricing_option: guestTicket.pricing_option || "fixed",
            tax_type: guestTicket.taxEnabled
              ? guestTicket.taxIncluded
                ? "Including Tax"
                : "Excluding Tax"
              : "No Tax",
            tax_options: guestTicket.taxOptions || newTicket.taxOptions,
            tax_registration_no:
              guestTicket.taxRegisTrationNumber ||
              newTicket.taxRegisTrationNumber ||
              null,
            selected_form: guestTicket.selected_form || null,
            form_details: guestTicket.form_details
              ? JSON.stringify(guestTicket.form_details)
              : "",
            schedule_sale_enabled: guestTicket.schedule_sale_enabled || "no",
            private_ticket: guestTicket.private_ticket || "no",
            ticket_min_order:
              Number.parseInt(guestTicket.ticket_min_order) || 1,
            ticket_max_order: 1000,
            show_promotional_label: guestTicket.show_promotional_label || "no",
            promotional_label_text: guestTicket.promotional_label_text || "",
            qrcode: guestTicket.qrcode ? "yes" : "no",
            ticket_status: guestTicket.ticket_status || "onsale",
            onsale_status:
              guestTicket.ticket_status === "onsale" ? "enable" : "disable",
            variable_prices: guestTicket.variable_prices
              ? guestTicket.variable_prices.map((price) => ({
                  price: Number.parseFloat(price.price) || 0,
                  valid_till:
                    price.valid_till ||
                    `${new Date().toISOString().split("T")[0]} 23:59:59`,
                }))
              : null,
            ticket_group: guestTicket.ticket_group || null,
            addons:
              guestSelectedAddons.length > 0
                ? guestSelectedAddons.map((addon) => ({
                    id: addon.id,
                    user_id: 1,
                    event_id: EventID,
                    isMandatory:
                      addon.is_mandatory || addon.isMandatory || false,
                    addons_type: addon.addon_type || addon.type || "single",
                    image: addon.image || "",
                    add_on_name: addon.addon_name || addon.name,
                    description: addon.description || "",
                    price_type: addon.addon_type === "free" ? "free" : "paid",
                    price:
                      Number.parseFloat(addon.addon_price || addon.price) || 0,
                    currency: addon.addon_currency || addon.currency || "INR",
                    tax_type: addon.tax_type,
                    tax_options: addon.tax_options || newTicket.taxOptions,
                    variant_options: Array.isArray(addon.variants)
                      ? addon.variants.map((variant) => ({
                          variant_name: variant.apiVariant.variant_name,
                          quantity_available:
                            variant.apiVariant.quantity_available,
                          variant_price: variant.apiVariant.variant_price,
                        }))
                      : [],
                    selected_variant:
                      addon.selected_variant || addon.selectedVariant
                        ? {
                            variant_name:
                              addon.selectedVariant?.variant_name || "",
                            variant_price:
                              addon.selectedVariant?.variant_price || 0,
                          }
                        : null,
                    linked_tickets:
                      addon.linkedTickets && addon.linkedTickets.length > 0
                        ? addon.linkedTickets.map((lt) => ({
                            ticket_id: lt.ticket_id,
                            max_quantity: lt.maxQuantity || 1,
                          }))
                        : [],
                    choose_quantity:
                      Number.parseInt(addon.choose_quantity) || 1,
                    quantity:
                      Number.parseInt(addon.addon_quantity || addon.quantity) ||
                      1,
                    addon_status:
                      addon.addon_status || addon.status || "onsale",
                    created_at: addon.created_at || new Date().toISOString(),
                  }))
                : [],
          };
        }
      } else {
        formattedData = {
          event_id: EventID,
          ticket_group_id: newTicket.group || null,
          attendee_details: {
            ticket_name: newTicket.name,
            description: newTicket.description || "",
            price:
              newTicket.pricingType === "paid"
                ? newTicket.priceOption === "fixed"
                  ? Number.parseFloat(newTicket.fixedPrice)
                  : Number.parseFloat(newTicket.variablePrices[0]?.price || 0)
                : null,
            quantity: newTicket.qtyAvailable
              ? Number.parseInt(newTicket.qtyAvailable)
              : 100000,
            start_sale: (() => {
              try {
                return newTicket.saleStartDate
                  ? `${
                      new Date(newTicket.saleStartDate)
                        .toISOString()
                        .split("T")[0]
                    } ${
                      newTicket.saleStartTime
                        ? new Date(newTicket.saleStartTime)
                            .toTimeString()
                            .split(" ")[0]
                        : "00:00:00"
                    }`
                  : null;
              } catch (e) {
                return null;
              }
            })(),
            end_sale: (() => {
              try {
                return newTicket.saleEndDate
                  ? `${
                      new Date(newTicket.saleEndDate)
                        .toISOString()
                        .split("T")[0]
                    } ${
                      newTicket.saleEndTime
                        ? new Date(newTicket.saleEndTime)
                            .toTimeString()
                            .split(" ")[0]
                        : "23:59:59"
                    }`
                  : null;
              } catch (e) {
                return null;
              }
            })(),
            ticket_type: newTicket.pricingType || "free",
            currency: newTicket.currency || "INR",
            pricing_option: newTicket.priceOption || "fixed",
            tax_type: newTicket.taxEnabled
              ? newTicket.taxIncluded
                ? "Including Tax"
                : "Excluding Tax"
              : "No Tax",
            tax_options: newTicket.taxOptions || [],
            tax_registration_no: newTicket.taxRegisTrationNumber || null,
            selected_form: selectedForm?.id || null,
            form_details: selectedForm
              ? JSON.stringify(selectedForm.fields)
              : "",
            schedule_sale: (() => {
              try {
                return newTicket.saleStartDate
                  ? `${
                      new Date(newTicket.saleStartDate)
                        .toISOString()
                        .split("T")[0]
                    } ${
                      newTicket.saleStartTime
                        ? new Date(newTicket.saleStartTime)
                            .toTimeString()
                            .split(" ")[0]
                        : "00:00:00"
                    }`
                  : null;
              } catch (e) {
                return null;
              }
            })(),
            schedule_sale_enabled: newTicket.showSchedule ? "yes" : "no",
            private_ticket: newTicket.isPrivate ? "yes" : "no",
            ticket_min_order: newTicket.showLimits
              ? Number.parseInt(newTicket.ticket_min_order) || 0
              : 0,
            ticket_max_order: newTicket.showLimits
              ? Number.parseInt(newTicket.ticket_max_order) || 0
              : 0,
            show_promotional_label: "yes",
            promotional_label_text: "Best Value",
            qrcode: newTicket.qrcode ? "yes" : "no",
            ticket_status: newTicket.ticketStatus || "paused",
            onsale_status:
              newTicket.ticketStatus === "onsale" ? "enable" : "enable",
            variable_prices:
              newTicket.priceOption === "variable"
                ? newTicket.variablePrices.map((price) => {
                    const defaultDate = "2025-05-05";
                    const defaultTime = "23:59:59";
                    let validDate;
                    try {
                      validDate = price.validUntilDate
                        ? new Date(price.validUntilDate)
                            .toISOString()
                            .split("T")[0]
                        : defaultDate;
                    } catch (e) {
                      validDate = defaultDate;
                    }
                    let validTime;
                    try {
                      validTime = price.validUntilTime
                        ? new Date(price.validUntilTime)
                            .toTimeString()
                            .split(" ")[0]
                        : defaultTime;
                    } catch (e) {
                      validTime = defaultTime;
                    }
                    return {
                      price: Number.parseFloat(price.price) || 0,
                      valid_till: `${validDate} ${validTime}`,
                    };
                  })
                : null,
            addons:
              selectedAddons.length > 0
                ? selectedAddons.map((addon) => ({
                    id: addon.id,
                    user_id: 1,
                    event_id: EventID,
                    isMandatory: addon.isMandatory || false,
                    addons_type: addon.type || "single",
                    add_on_name: addon.name,
                    description: addon.description || "",
                    price_type: addon.price_type || "paid",
                    price:
                      Number.parseFloat(addon.price) ||
                      (addon.selectedVariant
                        ? Number.parseFloat(addon.selectedVariant.variant_price)
                        : 0),
                    currency: addon.currency || "INR",
                    tax_type: addon.tax_type,
                    tax_options: addon.tax_options || newTicket.taxOptions,
                    variant_options: Array.isArray(addon.variants)
                      ? addon.variants.map((variant) => ({
                          variant_name: variant.apiVariant.variant_name,
                          quantity_available:
                            variant.apiVariant.quantity_available,
                          variant_price: variant.apiVariant.variant_price,
                        }))
                      : [],
                    selected_variant: addon.selectedVariant
                      ? {
                          variant_name: addon.selectedVariant.variant_name,
                          variant_price: addon.selectedVariant.variant_price,
                        }
                      : null,
                    linked_tickets:
                      addon.linkedTickets && addon.linkedTickets.length > 0
                        ? addon.linkedTickets.map((lt) => ({
                            ticket_id: lt.ticket_id,
                            max_quantity: lt.maxQuantity || 1,
                          }))
                        : [],
                    choose_quantity: addon.choose_quantity || 1,
                    quantity: addon.quantity || 1,
                    addon_status: addon.status || "onsale",
                    created_at: addon.created_at || new Date().toISOString(),
                  }))
                : [],
          },
        };

        if (guestTicket) {
          formattedData.guest_details = {
            ticket_name: guestTicket.ticket_name,
            description: guestTicket.description || "",
            price: guestTicket.price,
            quantity: guestTicket.qtyAvailable
              ? Number.parseInt(guestTicket.qtyAvailable)
              : 10000,
            start_sale: newTicket.saleStartDate
              ? `${
                  new Date(newTicket.saleStartDate).toISOString().split("T")[0]
                } ${
                  newTicket.saleStartTime
                    ? new Date(newTicket.saleStartTime)
                        .toTimeString()
                        .split(" ")[0]
                    : "00:00:00"
                }`
              : null,
            end_sale: newTicket.saleEndDate
              ? `${
                  new Date(newTicket.saleEndDate).toISOString().split("T")[0]
                } ${
                  newTicket.saleEndTime
                    ? new Date(newTicket.saleEndTime)
                        .toTimeString()
                        .split(" ")[0]
                    : "23:59:59"
                }`
              : null,
            ticket_type: guestTicket.ticket_type || "free",
            currency: guestTicket.currency || "INR",
            pricing_option: guestTicket.priceOption || "fixed",
            tax_type: guestTicket.taxEnabled
              ? guestTicket.taxIncluded
                ? "Including Tax"
                : "Excluding Tax"
              : "No Tax",
            tax_options: guestTicket.taxOptions || newTicket.taxOptions,
            tax_registration_no: guestTicket.tax_registration_number || null,
            selected_form: selectedForm?.id || null,
            form_details: selectedForm
              ? JSON.stringify(selectedForm.fields)
              : "",
            schedule_sale_enabled: newTicket.showSchedule ? "yes" : "no",
            private_ticket: "no",
            ticket_min_order: guestTicket.showLimits
              ? Number.parseInt(guestTicket.minLimit) || 1
              : 1,
            ticket_max_order: 1000,
            show_promotional_label: "no",
            promotional_label_text: "",
            qrcode: guestTicket.qrcode ? "yes" : "no",
            ticket_status: "onsale",
            onsale_status: "enable",
            variable_prices:
              guestTicket.priceOption === "variable"
                ? guestTicket.variablePrices.map((price) => {
                    const defaultDate = new Date().toISOString().split("T")[0];
                    const defaultTime = new Date().toTimeString().split(" ")[0];
                    let validDate;
                    try {
                      validDate = price.validUntilDate
                        ? new Date(price.validUntilDate)
                            .toISOString()
                            .split("T")[0]
                        : defaultDate;
                    } catch (e) {
                      validDate = defaultDate;
                    }
                    let validTime;
                    try {
                      validTime = price.validUntilTime
                        ? new Date(price.validUntilTime)
                            .toTimeString()
                            .split(" ")[0]
                        : defaultTime;
                    } catch (e) {
                      validTime = defaultTime;
                    }
                    return {
                      price: Number.parseFloat(price.price) || 0,
                      valid_till: `${validDate} ${validTime}`,
                    };
                  })
                : null,
            addons:
              guestSelectedAddons.length > 0
                ? guestSelectedAddons.map((addon) => ({
                    id: addon.id,
                    user_id: 1,
                    event_id: EventID,
                    isMandatory:
                      addon.is_mandatory || addon.isMandatory || false,
                    addons_type: addon.addon_type || addon.type || "single",
                    image: addon.image || "",
                    add_on_name: addon.addon_name || addon.name,
                    description: addon.description || "",
                    price_type: addon.addon_type === "free" ? "free" : "paid",
                    price:
                      Number.parseFloat(addon.addon_price || addon.price) || 0,
                    currency: addon.addon_currency || addon.currency || "INR",
                    tax_type: addon.tax_type,
                    tax_options: addon.tax_options || newTicket.taxOptions,
                    variant_options: Array.isArray(addon.variant_options)
                      ? addon.variant_options.map((variant) => ({
                          variant_name: variant.variant_name,
                          quantity_available: variant.quantity_available,
                          variant_price: variant.variant_price,
                        }))
                      : [],

                    selected_variant:
                      addon.selected_variant || addon.selectedVariant
                        ? {
                            variant_name:
                              addon.selectedVariant?.variant_name || "",
                            variant_price:
                              addon.selectedVariant?.variant_price || 0,
                          }
                        : null,
                    linked_tickets:
                      addon.linkedTickets && addon.linkedTickets.length > 0
                        ? addon.linkedTickets.map((lt) => ({
                            ticket_id: lt.ticket_id,
                            max_quantity: lt.maxQuantity || 1,
                          }))
                        : [],
                    choose_quantity:
                      Number.parseInt(addon.addon_quantity || addon.quantity) ||
                      1,
                    quantity:
                      Number.parseInt(addon.addon_quantity || addon.quantity) ||
                      1,
                    addon_status:
                      addon.addon_status || addon.status || "onsale",
                    created_at: addon.created_at || new Date().toISOString(),
                  }))
                : [],
          };
        }
      }
      console.log("Insert response:", formattedData);
      const response =
        editMode && ticketToEdit && ticketToEdit.id
          ? await UpdateEventTickets(formattedData)
          : await InsertEventTicket(formattedData);
      if (!editMode) {
        console.log("Insert response:", response);
      }
      // setNotification({
      //   show: true,
      //   type: "success",
      //   message: editMode
      //     ? "Ticket updated successfully!"
      //     : "Ticket created successfully!",
      // });
      showToast(response.message, response.success ? "success" : "error");
      getValidation();

      setTimeout(() => {
        onHide();
        onUpdate();
      }, 2000);

      return response;
    } catch (error) {
      console.error(
        editMode ? "Error updating ticket:" : "Error creating ticket:",
        error.response?.data || error.message
      );
      // setNotification({
      //   show: true,
      //   type: "error",
      //   message: editMode
      //     ? `Failed to update ticket: ${error.response?.data?.message || "Please try again."}`
      //     : `Failed to create ticket: ${error.response?.data?.message || "Please try again."}`,
      // })
    }
  };

  const handleAddonSelection = (addon) => {
    const isSelected = selectedAddons.some((item) => item.id === addon.id);

    if (isSelected) {
      setSelectedAddons(selectedAddons.filter((item) => item.id !== addon.id));
    } else {
      const selectedVariant =
        addon.hasVariants && addon.variants.length > 0
          ? addon.variants[0]
          : null;

      setSelectedAddons([
        ...selectedAddons,
        {
          ...addon,
          quantity: addon.quantity || 1,
          choose_quantity: addon.choose_quantity || 1,
          isMandatory: false,
          selectedVariant: selectedVariant
            ? {
                name: selectedVariant.name,
                price: selectedVariant.price,
                variant_name: selectedVariant.apiVariant.variant_name,
                variant_price: selectedVariant.apiVariant.variant_price,
              }
            : null,
          tax_options: newTicket.taxOptions,
          linkedTickets: addon.linkedTickets.map((lt) => ({ ...lt })),
        },
      ]);
    }
  };

  const handleGuestAddonSelection = (addon) => {
    const isSelected = guestSelectedAddons.some((item) => item.id === addon.id);
    if (isSelected) {
      setGuestSelectedAddons(
        guestSelectedAddons.filter((item) => item.id !== addon.id)
      );
    } else {
      const selectedVariant =
        addon.hasVariants && addon.variants.length > 0
          ? addon.variants[0]
          : null;
      setGuestSelectedAddons([
        ...guestSelectedAddons,
        {
          ...addon,
          quantity: addon.quantity || 1,
          choose_quantity: addon.choose_quantity || 1,
          isMandatory: false,
          selectedVariant: selectedVariant
            ? {
                name: selectedVariant.name,
                price: selectedVariant.price,
                variant_name: selectedVariant.apiVariant.variant_name,
                variant_price: selectedVariant.apiVariant.variant_price,
              }
            : null,
          tax_options: newTicket.taxOptions,
          linkedTickets: addon.linkedTickets.map((lt) => ({ ...lt })),
        },
      ]);
    }
  };

  const toggleAddonMandatory = (addonId) => {
    setSelectedAddons(
      selectedAddons.map((addon) =>
        addon.id === addonId
          ? { ...addon, isMandatory: !addon.isMandatory }
          : addon
      )
    );
  };

  const toggleGuestAddonMandatory = (addonId) => {
    setGuestSelectedAddons(
      guestSelectedAddons.map((addon) =>
        addon.id === addonId
          ? { ...addon, isMandatory: !addon.isMandatory }
          : addon
      )
    );
  };

  const handleGuestAddonQuantityChange = (addonId, chooseQuantity) => {
    setGuestSelectedAddons(
      guestSelectedAddons.map((addon) =>
        addon.id === addonId
          ? { ...addon, choose_quantity: chooseQuantity }
          : addon
      )
    );
  };

  const handleGuestRemoveAddon = (addonId) => {
    setGuestSelectedAddons(
      guestSelectedAddons.filter((addon) => addon.id !== addonId)
    );
  };

  const handleAddonQuantityChange = (addonId, chooseQuantity) => {
    console.log("[v0] handleAddonQuantityChange called:", {
      addonId,
      chooseQuantity,
    });
    console.log("[v0] Current selectedAddons before update:", selectedAddons);

    setSelectedAddons(
      selectedAddons.map((addon) =>
        addon.id === addonId
          ? { ...addon, choose_quantity: chooseQuantity }
          : addon
      )
    );

    // Log after state update (will show in next render)
    console.log("[v0] State update triggered for addon:", addonId);
  };

  const handleRemoveAddon = (addonId) => {
    setSelectedAddons(selectedAddons.filter((addon) => addon.id !== addonId));
  };

  const handleLinkedTicketQuantityChange = (addonId, ticketId, quantity) => {
    setSelectedAddons((prev) =>
      prev.map((addon) =>
        addon.id === addonId
          ? {
              ...addon,
              linkedTickets: addon.linkedTickets.map((lt) =>
                lt.ticket_id === ticketId
                  ? { ...lt, maxQuantity: quantity }
                  : lt
              ),
            }
          : addon
      )
    );
  };

  const handleGuestLinkedTicketQuantityChange = (
    addonId,
    ticketId,
    quantity
  ) => {
    setGuestSelectedAddons((prev) =>
      prev.map((addon) =>
        addon.id === addonId
          ? {
              ...addon,
              linkedTickets: addon.linkedTickets.map((lt) =>
                lt.ticket_id === ticketId
                  ? { ...lt, maxQuantity: quantity }
                  : lt
              ),
            }
          : addon
      )
    );
  };

  const validateForm = (tab, isGuestTicket = false) => {
    let isValid = true;
    const newErrors = { ...errors };

    if (!isGuestTicket) {
      if (tab === "basic" || tab === "all") {
        if (!newTicket.name.trim()) {
          newErrors.name = "Ticket name is required";
          isValid = false;
        } else {
          newErrors.name = "";
        }
      }

      if (
        (tab === "pricing" || tab === "all") &&
        newTicket.pricingType === "paid"
      ) {
        if (!newTicket.currency) {
          newErrors.currency = "Currency is required";
          isValid = false;
        } else {
          newErrors.currency = "";
        }

        // Validate price based on price option
        if (newTicket.priceOption === "fixed") {
          const fixedPriceError = validatePrice(
            newTicket.fixedPrice,
            "fixed price"
          );
          if (fixedPriceError) {
            newErrors.fixedPrice = fixedPriceError;
            isValid = false;
          } else {
            newErrors.fixedPrice = "";
          }
        } else if (
          newTicket.priceOption === "variable" &&
          newTicket.variablePrices &&
          newTicket.variablePrices.length > 0
        ) {
          const firstPriceError = validatePrice(
            newTicket.variablePrices[0].price,
            "price"
          );
          if (firstPriceError) {
            newErrors.variablePrice_0 = firstPriceError;
            isValid = false;
          } else {
            newErrors.variablePrice_0 = "";
          }
        }
      }

      if (tab === "form" || tab === "all") {
        if (!selectedForm || !selectedForm.id) {
          newErrors.selectedForm = "Please select a form";
          isValid = false;
        } else {
          newErrors.selectedForm = "";
        }
      }
    } else {
      if (tab === "basic" || tab === "all") {
        if (!guestTicketState.name.trim()) {
          newErrors.guestName = "Guest ticket name is required";
          isValid = false;
        } else {
          newErrors.guestName = "";
        }
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  // Helper function for price validation (add this if not already present)
  const validatePrice = (value, fieldName = "price") => {
    const numValue = Number.parseFloat(value);
    if (!value || value.trim() === "") {
      return `${
        fieldName.charAt(0).toUpperCase() + fieldName.slice(1)
      } is required.`;
    }
    if (isNaN(numValue) || numValue <= 0) {
      return `${
        fieldName.charAt(0).toUpperCase() + fieldName.slice(1)
      } must be a positive number.`;
    }
    return "";
  };

  const handleCreateTicket = (is_draft = false) => {
    if (validateForm("all")) {
      submitTicketToAPI(is_draft);
    }
  };

  // const handleNext = () => {
  //   if (activeTab === "basic" && validateForm("basic")) {
  //     setActiveTab("pricing")
  //   } else if (activeTab === "pricing" && validateForm("pricing")) {
  //     setActiveTab("form")
  //   } else if (activeTab === "form" && validateForm("form")) {
  //     setActiveTab("settings")
  //   } else if (activeTab === "settings") {
  //     handleCreateTicket()
  //   }
  // }
  const handleNext = () => {
    const steps = ["basic", "pricing", "form", "settings"];
    const currentIndex = steps.indexOf(activeTab);

    if (currentIndex === -1) return;

    if (currentIndex < steps.length - 1) {
      if (!validateForm(steps[currentIndex])) {
        showToast("Please fill all required fields", "error");
        return;
      }
      setActiveTab(steps[currentIndex + 1]);
    } else {
      handleCreateTicket();
    }
  };

  useEffect(() => {
    fetchAddons();
  }, []);

  useEffect(() => {
    if (editMode && ticketToEdit) {
      let formattedVariablePrices = [];
      if (ticketToEdit.selected_form && formsList.length > 0) {
      const matchedForm = formsList.find(
        f => f.id.toString() === ticketToEdit.selected_form.toString()
      );
      if (matchedForm) {
        setSelectedForm(matchedForm);
      }
    }
      if (
        ticketToEdit.variable_prices &&
        Array.isArray(ticketToEdit.variable_prices) &&
        ticketToEdit.variable_prices.length > 0
      ) {
        formattedVariablePrices = ticketToEdit.variable_prices.map((price) => {
          let validDate = null;
          let validTime = null;
          if (price.valid_till) {
            try {
              const dateObj = new Date(price.valid_till);
              validDate = dateObj;
              validTime = dateObj;
            } catch (e) {}
          }
          return {
            price: price.price?.toString() || "",
            validUntilDate: validDate,
            validUntilTime: validTime,
          };
        });
      } else if (
        Array.isArray(ticketToEdit.variablePrices) &&
        ticketToEdit.variablePrices.length > 0
      ) {
        formattedVariablePrices = ticketToEdit.variablePrices.map((price) => ({
          price: price.price?.toString() || "",
          validUntilDate: price.validUntilDate
            ? new Date(price.validUntilDate)
            : null,
          validUntilTime: price.validUntilTime
            ? new Date(price.validUntilTime)
            : null,
        }));
        
      } else {
        formattedVariablePrices = [
          { price: "", validUntilDate: null, validUntilTime: null },
        ];
      }

      const formatApiDate = (dateStr) => {
        if (!dateStr) return null;
        try {
          const date = new Date(dateStr);
          const yyyy = date.getFullYear();
          const mm = String(date.getMonth() + 1).padStart(2, "0");
          const dd = String(date.getDate()).padStart(2, "0");
          const hh = String(date.getHours()).padStart(2, "0");
          const mi = String(date.getMinutes()).padStart(2, "0");
          const ss = String(date.getSeconds()).padStart(2, "0");
          return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
        } catch (e) {
          return null;
        }
      };

      const taxType = (
        ticketToEdit._originalData?.tax_type ||
        ticketToEdit.tax_type ||
        ""
      )
        .trim()
        .toLowerCase();
      const taxEnabled = taxType !== "no tax" && taxType !== "";
      let taxIncluded = false;
      let taxDisplay = "add_to_total";
      if (
        taxType.includes("including") ||
        taxType.includes("include") ||
        taxType.includes("included")
      ) {
        taxIncluded = true;
        taxDisplay = "include_in_price";
      } else if (
        taxType.includes("excluding") ||
        taxType.includes("exclude") ||
        taxType.includes("added") ||
        taxType.includes("add_to_total")
      ) {
        taxIncluded = false;
        taxDisplay = "add_to_total";
      }

      const totalTaxRate = ticketToEdit.tax_options
        ? ticketToEdit.tax_options
            .reduce((sum, t) => sum + Number(t.tax_percentage || 0), 0)
            .toString()
        : "18";

      const taxName = ticketToEdit.tax_options
        ? ticketToEdit.tax_options.map((t) => t.tax_name).join(", ")
        : "GST";

      setNewTicket((prev) => ({
        ...prev,
        name: ticketToEdit.ticket_name || ticketToEdit.name || "",
        qtyAvailable:
          ticketToEdit.quantity?.toString() ||
          ticketToEdit.qtyAvailable?.toString() ||
          "",
        description: ticketToEdit.description || "",
        group:
          ticketToEdit.ticket_group ||
          ticketToEdit.group ||
          ticketToEdit.ticket_group_id ||
          "",
        pricingType:
          ticketToEdit.ticket_type || ticketToEdit.pricingType || "free",
        currency: ticketToEdit.currency || "",
        priceOption:
          ticketToEdit.pricing_option || ticketToEdit.priceOption || "variable",
        fixedPrice:
          ticketToEdit.price?.toString() || ticketToEdit.fixedPrice || "",
        variablePrices: formattedVariablePrices,
        taxEnabled: taxEnabled,
        taxIncluded: taxIncluded,
        taxDisplay: taxDisplay,
        taxRate: totalTaxRate,
        taxName: taxName,
        taxType:
          ticketToEdit._originalData?.tax_type ||
          ticketToEdit.tax_type ||
          "No Tax",
        taxOptions: ticketToEdit.tax_options || prev.taxOptions,
        taxRegisTrationNumber:
          ticketToEdit.tax_registration_no || prev.taxRegisTrationNumber,
        isPrivate: ticketToEdit.private_ticket === "yes",
        showSchedule: ticketToEdit.schedule_sale_enabled === "yes",
        saleStartDate: formatApiDate(ticketToEdit.start_sale),
        saleStartTime: formatApiDate(ticketToEdit.start_sale),
        saleEndDate: formatApiDate(ticketToEdit.end_sale),
        saleEndTime: formatApiDate(ticketToEdit.end_sale),
        showLimits:
          ticketToEdit.ticket_min_order !== undefined ||
          ticketToEdit.ticket_max_order !== undefined,
        ticket_min_order: ticketToEdit.ticket_min_order?.toString() || "1",
        ticket_max_order: ticketToEdit.ticket_max_order?.toString() || "",
        qrcode: ticketToEdit.qrcode === "yes" || ticketToEdit.qrcode === true,
       ticketStatus: 
  ticketToEdit.ticket_status === "onsale" || 
  ticketToEdit.onsale_status === "enable"
    ? "onsale"
    : "paused",
        selected_form: ticketToEdit.selected_form || null,
      }));

      if (ticketToEdit.description) {
        setShowGuestDescription(true);
      }

      if (
        ticketToEdit.ticket_group ||
        ticketToEdit.group ||
        ticketToEdit.ticket_group_id
      ) {
        setShowGroup(true);
      }

      if (ticketToEdit.guest_details || ticketToEdit.guestTicket) {
        const guestTicketData =
          ticketToEdit.guest_details || ticketToEdit.guestTicket;
        setShowGuestTicket(true);
        let guestFormattedVariablePrices = [];
        if (
          guestTicketData.variable_prices &&
          Array.isArray(guestTicketData.variable_prices) &&
          guestTicketData.variable_prices.length > 0
        ) {
          guestFormattedVariablePrices = guestTicketData.variable_prices.map(
            (price) => {
              let validDate = null;
              let validTime = null;
              if (price.valid_till) {
                try {
                  const dateObj = new Date(price.valid_till);
                  validDate = dateObj;
                  validTime = dateObj;
                } catch (e) {}
              }
              return {
                price: price.price?.toString() || "",
                validUntilDate: validDate,
                validUntilTime: validTime,
              };
            }
          );
        } else if (
          Array.isArray(guestTicketData.variablePrices) &&
          guestTicketData.variablePrices.length > 0
        ) {
          guestFormattedVariablePrices = guestTicketData.variablePrices.map(
            (price) => ({
              price: price.price?.toString() || "",
              validUntilDate: price.validUntilDate
                ? new Date(price.validUntilDate)
                : null,
              validUntilTime: price.validUntilTime
                ? new Date(price.validUntilTime)
                : null,
            })
          );
        } else {
          guestFormattedVariablePrices = [
            { price: "", validUntilDate: null, validUntilTime: null },
          ];
        }

        const guestTaxType = (guestTicketData.tax_type || "")
          .trim()
          .toLowerCase();
        const guestTaxEnabled =
          guestTaxType !== "no tax" && guestTaxType !== "";
        let guestTaxIncluded = false;
        let guestTaxDisplay = "add_to_total";
        if (
          guestTaxType.includes("including") ||
          guestTaxType.includes("include") ||
          guestTaxType.includes("included")
        ) {
          guestTaxIncluded = true;
          guestTaxDisplay = "include_in_price";
        } else if (
          guestTaxType.includes("excluding") ||
          guestTaxType.includes("exclude") ||
          guestTaxType.includes("added") ||
          guestTaxType.includes("add_to_total")
        ) {
          guestTaxIncluded = false;
          guestTaxDisplay = "add_to_total";
        }

        const guestTotalTaxRate = guestTicketData.tax_options
          ? guestTicketData.tax_options
              .reduce((sum, t) => sum + Number(t.tax_percentage || 0), 0)
              .toString()
          : newTicket.taxRate;

        const guestTaxName = guestTicketData.tax_options
          ? guestTicketData.tax_options.map((t) => t.tax_name).join(", ")
          : newTicket.taxName;

        const formattedGuestTicket = {
          name: guestTicketData.ticket_name || guestTicketData.name || "",
          qtyAvailable:
            guestTicketData.quantity?.toString() ||
            guestTicketData.qtyAvailable?.toString() ||
            "",
          description: guestTicketData.description || "",
          pricingType:
            guestTicketData.ticket_type ||
            guestTicketData.pricingType ||
            "free",
          currency: guestTicketData.currency || "INR",
          priceOption:
            guestTicketData.pricing_option ||
            guestTicketData.priceOption ||
            "fixed",
          fixedPrice:
            guestTicketData.price?.toString() ||
            guestTicketData.fixedPrice ||
            "",
          variablePrices: guestFormattedVariablePrices,
          taxEnabled: guestTaxEnabled,
          taxIncluded: guestTaxIncluded,
          taxDisplay: guestTaxDisplay,
          taxRate: guestTotalTaxRate,
          taxName: guestTaxName,
          taxOptions: guestTicketData.tax_options || newTicket.taxOptions,
          selected_form: guestTicketData.selectedForm?.id || "not setted",
          taxRegisTrationNumber:
            guestTicketData.tax_registration_no ||
            newTicket.taxRegisTrationNumber,
          showLimits: true,
          minLimit: guestTicketData.ticket_min_order?.toString() || "1",
          maxLimit: 1000,
          qrcode:
            guestTicketData.qrcode === "yes" || guestTicketData.qrcode === true,
        };

        setGuestTicketState(formattedGuestTicket);
        setGuestTicket(formattedGuestTicket);
        if (guestTicketData.description) {
          setShowGuestDescription(true);
        }
      }

      const processAddons = (addonsList, setAddonsFn) => {
        fetchAddons().then(() => {
          const formattedAddons = addonsList.map((addon) => {
            const variants = Array.isArray(addon.variant_options)
              ? addon.variant_options.map((v, idx) => ({
                  id: idx + 1,
                  name: v.variant_name,
                  price: v.variant_price,
                  apiVariant: v,
                }))
              : [];

            const selectedVariant = addon.selected_variant
              ? {
                  name: addon.selected_variant.variant_name,
                  price: addon.selected_variant.variant_price,
                  variant_name: addon.selected_variant.variant_name,
                  variant_price: addon.selected_variant.variant_price,
                }
              : variants.length > 0
              ? {
                  name: variants[0].name,
                  price: variants[0].price,
                  variant_name: variants[0].apiVariant.variant_name,
                  variant_price: variants[0].apiVariant.variant_price,
                }
              : null;

            let chooseQuantity = addon.choose_quantity || 1;
            if (
              ticketToEdit &&
              ticketToEdit.id &&
              addon.linked_tickets &&
              addon.linked_tickets.length > 0
            ) {
              const linkedTicket = addons.find(
                (lt) => lt.ticket_id === ticketToEdit.id
              );
              if (linkedTicket) {
                chooseQuantity = linkedTicket.max_quantity;
              }
            }

            return {
              id: addon.id,
              name: addon.add_on_name,
              description: addon.description || "",
              price: addon.price,
              currency: addon.currency || "INR",
              price_type: addon.price_type || "paid",
              variants,
              hasVariants: variants.length > 0,
              type: addon.addons_type || addon.type || "single",
              status: addon.addon_status || addon.status || "onsale",
              quantity: addon.quantity || 1,
              choose_quantity: chooseQuantity, // Use calculated chooseQuantity
              isMandatory: addon.is_mandatory || addon.isMandatory || false,
              selectedVariant,
              tax_type: addon.tax_type,
              tax_options: addon.tax_options || newTicket.taxOptions,
              linkedTickets: addon.linked_tickets
                ? addon.linked_tickets.map((lt) => ({
                    ticket_id: lt.ticket_id,
                    maxQuantity: lt.max_quantity || 1,
                  }))
                : [],
            };
          });
          setAddonsFn(formattedAddons);
        });
      };

      if (
        ticketToEdit.addons &&
        Array.isArray(ticketToEdit.addons) &&
        ticketToEdit.addons.length > 0
      ) {
        processAddons(ticketToEdit.addons, setSelectedAddons);
      } else if (
        ticketToEdit.ticket_addons &&
        Array.isArray(ticketToEdit.ticket_addons) &&
        ticketToEdit.ticket_addons.length > 0
      ) {
        processAddons(ticketToEdit.ticket_addons, setSelectedAddons);
      } else if (
        ticketToEdit.attendee_details &&
        ticketToEdit.attendee_details.addons
      ) {
        processAddons(ticketToEdit.attendee_details.addons, setSelectedAddons);
      }

      const guestTicketData =
        ticketToEdit.guest_details || ticketToEdit.guestTicket;
      if (
        guestTicketData &&
        guestTicketData.addons &&
        Array.isArray(guestTicketData.addons) &&
        guestTicketData.addons.length > 0
      ) {
        processAddons(guestTicketData.addons, setGuestSelectedAddons);
      } else if (
        guestTicketData &&
        guestTicketData.ticket_addons &&
        Array.isArray(guestTicketData.ticket_addons) &&
        guestTicketData.ticket_addons.length > 0
      ) {
        processAddons(guestTicketData.ticket_addons, setGuestSelectedAddons);
      }
    }
  }, [editMode, ticketToEdit,formsList]);

  useEffect(() => {
    GetFormes(EventID)
      .then((res) => {
        if (!res || !res.data || !res.data.forms) {
          return;
        }

        const formsArray = res.data.forms;

        if (!Array.isArray(formsArray)) {
          return;
        }

        const simplifiedForms = formsArray.map((formData) => {
          let parsedFields = [];

          if (formData.fileds) {
            try {
              let fieldsString = formData.fileds;

              if (
                typeof fieldsString === "string" &&
                fieldsString.startsWith('"') &&
                fieldsString.endsWith('"')
              ) {
                fieldsString = fieldsString.slice(1, -1);
              }

              fieldsString = fieldsString
                .replace(/\\"/g, '"')
                .replace(/\\\\/g, "\\")
                .replace(/\\n/g, "\n")
                .replace(/\\r/g, "\r")
                .replace(/\\t/g, "\t");

              parsedFields = JSON.parse(fieldsString);
            } catch (parseError) {
              console.error(
                "Error parsing fields for form",
                formData.id,
                ":",
                parseError
              );
              parsedFields = [];
            }
          }

          return {
            id: formData.id,
            name: formData.form_title || `Untitled Form ${formData.id}`,
            event_id: formData.event_id || EventID,
            form_type: formData.form_type || 1,
            form_id: formData.form_id,
            fields: parsedFields,
            description: formData.form_description || "",
            status: formData.status || "active",
            form_title: formData.form_title,
            form_description: formData.form_description,
          };
        });

        setFormsList(simplifiedForms);
        setIsLoadingForms(false);
      })
      .catch((error) => {
        setIsLoadingForms(false);
      });
  }, [EventID]);

  const handleFormSelect = (form) => {
    setSelectedForm(form);
    setShowFormDropdown(false);
  };

  const handleCreateGuestTicket = (
    guestTicketData,
    guestTicketApiData,
    editId = null
  ) => {
    setGuestTicket(guestTicketData);
    setShowGuestTicketForm(false);
    setShowGuestTicket(true);

    setGuestSelectedAddons(guestTicketData.addons || []);

    setNotification({
      show: true,
      type: "success",
      message: `Guest ticket ${editId ? "updated" : "added"} successfully!`,
    });
  };

  const handleAddGuestTicket = () => {
    setGuestTicketMode("add");
    setShowGuestTicketForm(true);
  };

  const handleRemoveGuestTicket = () => {
    setShowGuestTicket(false);
    setGuestTicket(null);
    setGuestTicketState({
      name: "",
      qtyAvailable: "",
      description: "",
      group: "",
      selected_form: null,
      form_details: null,
      pricingType: "free",
      currency: "INR",
      priceOption: "fixed",
      fixedPrice: "",
      variablePrices: [
        { price: "", validUntilDate: null, validUntilTime: null },
      ],
      taxEnabled: newTicket.taxEnabled,
      taxIncluded: newTicket.taxIncluded,
      taxRate: newTicket.taxRate,
      taxName: newTicket.taxName,
      taxOptions: newTicket.taxOptions,
      taxRegisTrationNumber: newTicket.taxRegisTrationNumber,
      taxDisplay: newTicket.taxDisplay,
      isPrivate: false,
      showSchedule: false,
      saleStartDate: null,
      saleStartTime: null,
      saleEndDate: null,
      saleEndTime: null,
      showLimits: true,
      ticket_min_order: "1",
      ticket_max_order: "1000",
      qrcode: false,
      ticketStatus: "onsale",
    });

    setGuestSelectedAddons([]);
  };

  if (!show) return null;

  if (showGuestTicketForm) {
    return (
      <GuestTicketForm
        show={show}
        onHide={onHide}
        setGuestSelectedAddons={setGuestSelectedAddons}
        guestSelectedAddons={guestSelectedAddons}
        onCreateGuestTicket={handleCreateGuestTicket}
        mainTicket={newTicket}
        guestTicketToEdit={guestTicket}
        fetchAddons={fetchAddons}
        addons={addons}
        isLoadingAddons={isLoadingAddons}
        selectedAddons={guestSelectedAddons}
        handleAddonSelection={handleGuestAddonSelection}
        toggleMandatory={toggleGuestAddonMandatory}
        handleQuantityChange={handleGuestAddonQuantityChange}
        handleVariantSelection={handleGuestVariantSelection}
        handleRemoveAddon={handleGuestRemoveAddon}
        handleLinkedTicketQuantityChange={handleGuestLinkedTicketQuantityChange}
        editMode={editMode}
        setShowGuestTicketForm={setShowGuestTicketForm}
        formsList={formsList}
        isLoadingForms={isLoadingForms}
        newTicket={newTicket}
        setShowGuestTicket={setShowGuestTicket}
        setGuestTicket={setGuestTicket}
        setNotification={setNotification}
        setShowAddOns={setShowAddOns}
      />
    );
  }

  return (
    <div
      className={`extraspace_search_div1 search_div${show ? " open" : ""}`}
      style={{}}
    >
      <ToastMessage />
      <div
        className="card member_master_sidebar_scrool"
        style={{ height: "100%", display: "flex", flexDirection: "column" }}
      >
        {/* Enhanced Modern Notification */}
        {notification.show && (
          <div
            style={{
              position: "fixed",
              top: "24px",
              right: "24px",
              zIndex: 9999,
              minWidth: "350px",
              backgroundColor:
                notification.type === "success" ? "#10b981" : "#ef4444",
              color: "#ffffff",
              borderRadius: "12px",
              padding: "16px 20px",
              boxShadow: "0 10px 40px rgba(0, 0, 0, 0.2)",
              display: "flex",
              alignItems: "center",
              gap: "12px",
              animation: "slideInRight 0.3s ease-out",
              backdropFilter: "blur(10px)",
            }}
          >
            <div
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "18px",
              }}
            >
              {notification.type === "success" ? (
                <FaCheck />
              ) : (
                <i className="fa fa-exclamation-circle"></i>
              )}
            </div>
            <span style={{ flex: 1, fontSize: "14px", fontWeight: "500" }}>
              {notification.message}
            </span>
            <button
              onClick={closeNotification}
              className="close-notification-btn"
            >
              <FaTimes />
            </button>
          </div>
        )}

        {/* Enhanced Modern Header */}
        <div className="common_sidebar_header">
          <div>
            <h5>
              {editMode ? ticketToEdit?.name || "Edit Ticket" : "Create Ticket"}
            </h5>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            {/* <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "6px 12px",
                  backgroundColor: "rgba(251, 191, 36, 0.2)",
                  borderRadius: "20px",
                  border: "1px solid rgba(251, 191, 36, 0.3)",
                  backdropFilter: "blur(10px)",
                }}
              >
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "#fbbf24",
                    boxShadow: "0 0 8px rgba(251, 191, 36, 0.5)",
                    animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
                  }}
                ></span>
                <span
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    color: "#ffffff",
                  }}
                >
                  Draft
                </span>
              </div> */}
            <button onClick={onHide} className="close-notification-btn">
              <FaTimes />
            </button>
          </div>
        </div>

        <div
          className="create-ticket-body"
          style={{
            flexGrow: 1,
            overflowY: "auto",
            backgroundColor: "#ffffffff",
          }}
        >
          {/* Enhanced Tab Navigation */}
          <div
            style={{
              padding: "24px 32px 15px",
              backgroundColor: "#ffffff",
              borderBottom: "2px solid #e5e7eb",
            }}
          >
            <div
              className="buon_create_tickets"
              style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}
            >
              <button
                onClick={() => setActiveTab("basic")}
                className={`tab-button ${
                  activeTab === "basic" ? "active" : ""
                }`}
              >
                <div
                  className={`tab-icon ${
                    activeTab === "basic" ? "active" : ""
                  }`}
                >
                  <LuTickets />
                </div>
                <span>Basic</span>
              </button>

              {/* PRICING TAB */}
              <button
                onClick={() => {
                  if (validateForm("basic")) {
                    setActiveTab("pricing");
                  } else {
                    showToast("Please fill all required fields", "error");
                  }
                }}
                className={`tab-button ${
                  activeTab === "pricing" ? "active" : ""
                }`}
              >
                <div
                  className={`tab-icon ${
                    activeTab === "pricing" ? "active" : ""
                  }`}
                >
                  <RiPriceTag2Fill />
                </div>
                <span>Pricing</span>
              </button>

              {/* FORM TAB */}
              <button
                onClick={() => {
                  if (validateForm("basic") && validateForm("pricing")) {
                    setActiveTab("form");
                  } else {
                    showToast("Please fill all required fields", "error");
                  }
                }}
                className={`tab-button ${activeTab === "form" ? "active" : ""}`}
              >
                <div
                  className={`tab-icon ${activeTab === "form" ? "active" : ""}`}
                >
                  <FaWpforms />
                </div>
                <span>Form</span>
              </button>

              {/* SETTINGS TAB */}
              <button
                onClick={() => {
                  if (
                    validateForm("basic") &&
                    validateForm("pricing") &&
                    validateForm("form")
                  ) {
                    setActiveTab("settings");
                  } else {
                    showToast("Please fill all required fields", "error");
                  }
                }}
                className={`tab-pill-btn ${
                  activeTab === "settings" ? "active" : ""
                }`}
              >
                <div
                  className={`tab-pill-icon ${
                    activeTab === "settings" ? "active" : ""
                  }`}
                >
                  <IoMdSettings />
                </div>
                <span>Settings</span>
              </button>
            </div>
          </div>

          {/* Tab Content */}
          <div>
            {activeTab === "basic" && (
              <BasicTab
                newTicket={newTicket}
                setNewTicket={setNewTicket}
                handleVariantSelection={handleVariantSelection}
                errors={errors}
                setErrors={setErrors}
                showDescription={showGuestDescription}
                setShowDescription={setShowGuestDescription}
                showGroup={showGroup}
                setShowGroup={setShowGroup}
                selectedAddons={selectedAddons}
                handleRemoveAddon={handleRemoveAddon}
                toggleAddonMandatory={toggleAddonMandatory}
                handleAddonQuantityChange={handleAddonQuantityChange}
                fetchAddons={fetchAddons}
                setShowAddonsModal={setShowAddonsModal}
                ticketId={editMode ? ticketToEdit?.id : null}
              />
            )}

            {activeTab === "pricing" && (
              <PricingTab
                newTicket={newTicket}
                setNewTicket={setNewTicket}
                errors={errors}
                setErrors={setErrors}
                handleAddVariablePrice={() => {
                  setNewTicket({
                    ...newTicket,
                    variablePrices: Array.isArray(newTicket.variablePrices)
                      ? [
                          ...newTicket.variablePrices,
                          {
                            price: "",
                            validUntilDate: null,
                            validUntilTime: null,
                          },
                        ]
                      : [
                          {
                            price: "",
                            validUntilDate: null,
                            validUntilTime: null,
                          },
                        ],
                  });
                }}
                handleVariablePriceChange={(index, field, value) => {
                  if (!Array.isArray(newTicket.variablePrices)) {
                    setNewTicket({
                      ...newTicket,
                      variablePrices: [
                        {
                          price: "",
                          validUntilDate: null,
                          validUntilTime: null,
                        },
                      ],
                    });
                    return;
                  }

                  const updatedPrices = [...newTicket.variablePrices];
                  updatedPrices[index] = {
                    ...updatedPrices[index],
                    [field]: value,
                  };
                  setNewTicket({ ...newTicket, variablePrices: updatedPrices });
                }}
                handleDeleteVariablePrice={(index) => {
                  const updatedPrices = [...newTicket.variablePrices];
                  updatedPrices.splice(index, 1);
                  setNewTicket({ ...newTicket, variablePrices: updatedPrices });
                }}
                handleDateChange={(index, date) => {
                  const updatedPrices = [...newTicket.variablePrices];
                  updatedPrices[index] = {
                    ...updatedPrices[index],
                    validUntilDate: date,
                  };
                  setNewTicket({ ...newTicket, variablePrices: updatedPrices });
                }}
                handleTimeChange={(index, time) => {
                  const updatedPrices = [...newTicket.variablePrices];
                  updatedPrices[index] = {
                    ...updatedPrices[index],
                    validUntilTime: time,
                  };
                  setNewTicket({ ...newTicket, variablePrices: updatedPrices });
                }}
              />
            )}

            {activeTab === "form" && (
              <FormTab
                selectedForm={selectedForm}
                setSelectedForm={setSelectedForm}
                handleFormSelect={handleFormSelect}
                EventID={EventID}
                setNewTicket={setNewTicket}
                guestTicketState={guestTicketState}
                formsList={formsList}
                isLoadingForms={isLoadingForms}
                newTicket={newTicket}
                errors={errors}
                setErrors={setErrors}
              />
            )}
            {activeTab === "settings" && (
              <SettingsTab
                newTicket={newTicket}
                editMode={editMode}
                setNewTicket={setNewTicket}
                showGuestTicket={showGuestTicket}
                guestTicket={guestTicket}
                guestTicketState={guestTicketState}
                setShowGuestTicketForm={setShowGuestTicketForm}
                handleRemoveGuestTicket={handleRemoveGuestTicket}
                setGuestTicket={setGuestTicket}
                setNotification={setNotification}
                toggleLimits={toggleLimits}
                toggleQRCode={() => {
                  setNewTicket({
                    ...newTicket,
                    qrcode: !newTicket.qrcode,
                  });
                }}
              />
            )}
          </div>
        </div>

        {/* Enhanced Modern Footer */}
        <div
          style={{
            padding: "20px 32px",
            borderTop: "1px solid #e5e7eb",
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "#ffffff",
            boxShadow: "0 -4px 12px rgba(0, 0, 0, 0.05)",
          }}
        >
          <button
            onClick={() => {
              if (activeTab === "basic") {
                onHide();
              } else if (activeTab === "pricing") {
                setActiveTab("basic");
              } else if (activeTab === "form") {
                setActiveTab("pricing");
              } else if (activeTab === "settings") {
                setActiveTab("form");
              }
            }}
            style={{
              padding: "12px 28px",
              backgroundColor: "#ffffff",
              color: "#374151",
              border: "2px solid #e5e7eb",
              borderRadius: "10px",
              fontSize: "14px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = "#f9fafb";
              e.currentTarget.style.borderColor = "#d1d5db";
              e.currentTarget.style.transform = "translateY(-1px)";
              e.currentTarget.style.boxShadow =
                "0 4px 12px rgba(0, 0, 0, 0.08)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = "#ffffff";
              e.currentTarget.style.borderColor = "#e5e7eb";
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            <FaArrowLeft style={{ fontSize: "12px" }} />
            <span>{activeTab === "basic" ? "Cancel" : "Back"}</span>
          </button>

          <div style={{ display: "flex", gap: "12px" }}>
            {activeTab === "settings" ? (
              <button
                onClick={handleCreateTicket}
                className="btn btn-outline-primary "
              >
                <FaCheck style={{ fontSize: "14px" }} />
                <span>Publish & Start Sale</span>
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background:
                      "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)",
                    pointerEvents: "none",
                  }}
                ></div>
              </button>
            ) : (
              <button onClick={handleNext} className="btn btn-outline-primary ">
                <span>Next</span>
                <FaArrowRight />
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background:
                      "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)",
                    pointerEvents: "none",
                  }}
                ></div>
              </button>
            )}
          </div>
        </div>
      </div>

      <AddonsModal
        isOpen={showAddonsModal}
        onClose={() => setShowAddonsModal(false)}
        addons={addons}
        isLoadingAddons={isLoadingAddons}
        selectedAddons={selectedAddons}
        handleAddonSelection={handleAddonSelection}
        toggleMandatory={toggleAddonMandatory}
        handleQuantityChange={handleAddonQuantityChange}
        handleVariantSelection={handleVariantSelection}
        handleRemoveAddon={handleRemoveAddon}
        handleLinkedTicketQuantityChange={handleLinkedTicketQuantityChange}
      />

      <style>
        {`
          @keyframes slideInRight {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }

          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
          }
        `}
      </style>
    </div>
  );
};

export default CreateTicket;
